import { authorizedFetch, baseUrl, buildHeaders } from "../../redux/api/common";

export const apiGenerateImageAI = async (payload) => {
  try {
    const response = await authorizedFetch(`${baseUrl}/recommendation/ai/content/image`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: buildHeaders()
    });

    if (!response.ok) {
      throw new Error("Erro na geração da imagem");
    }

    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    return imageUrl;
  } catch (error) {
    return Promise.reject(error);
  }
}
